import { useEffect } from "react";

export const useF5PageCheck = () => {
  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);
}
